import React from 'react'

import {
  useResolvedPath,
  Link as ReactRouterLink,
  useMatch,
  To,
} from 'react-router-dom'

import { Link } from '@chakra-ui/layout'
import { Icon } from '@chakra-ui/icons'

type NavLinkProps = {
  icon: React.ElementType
  to: To
  onClick?: React.MouseEventHandler<HTMLAnchorElement>
  children: string
}

export function NavLink({ icon, to, onClick, children }: NavLinkProps) {
  const resolved = useResolvedPath(to)
  const match = useMatch({ path: resolved.pathname, end: true })

  const bg = React.useMemo(() => {
    return match ? 'white' : 'whiteAlpha.700'
  }, [match])

  return (
    <Link
      as={ReactRouterLink}
      to={to}
      onClick={onClick}
      display="flex"
      alignItems="center"
      paddingX="1rem"
      marginX="0.5rem"
      paddingY="0.75rem"
      cursor="pointer"
      color="parkoff.gray.900"
      background={match ? 'white' : 'none'}
      borderRadius="3.125rem"
      _hover={{
        bg: bg,
        color: 'black',
        borderRadius: '3.125rem',
      }}
      role="group"
      transition=".15s ease"
    >
      <Icon
        as={icon}
        marginRight="0.5625rem"
        width="1.25rem"
        height="1.25rem"
      />

      {children}
    </Link>
  )
}
